import React from "react";
import { usePackages } from "@/lib/api";
import Seo from "@/components/common/Seo";
import SectionHeading from "@/components/common/SectionHeading";
import PackageCard from "@/components/products/PackageCard";

export default function Packages() {
  const { data: packages = [] } = usePackages();

  return (
    <div data-testid="packages-page" className="bg-cream">
      <Seo title="Hazır Paketler" description="Mangal, steak gecesi, aile, burger ve tavuk şöleni paketleri. Sofranızı tek tıkla kurun, WhatsApp ile sipariş verin." />
      <section className="border-b border-dashed border-bordo/30 pt-16 pb-12">
        <div className="mx-auto max-w-7xl px-4 sm:px-6 lg:px-8">
          <SectionHeading as="h1" eyebrow="Hazır Paketler" title="Tek Tıkla Hazır Sofralar" description="Mangaldan steak gecesine, aile sofrasından burger keyfine; özenle hazırlanmış paketleri tek dokunuşla sipariş listenize ekleyin." />
        </div>
      </section>

      <section className="mx-auto max-w-7xl px-4 py-16 sm:px-6 lg:px-8">
        <div className="grid grid-cols-1 gap-6 sm:grid-cols-2 lg:grid-cols-3">
          {packages.map((pkg) => <PackageCard key={pkg.slug} pkg={pkg} />)}
        </div>
      </section>
    </div>
  );
}
